const textSize = ['xs', 'sm', 'md', 'lg'] as const;

export type TextSizeType = typeof textSize[number];

export interface TextInterface {
    /**
     * font-size
     */
    fs: number,

    /**
     * line-height
     */
    lh: number,
}

export interface TextThemeInterface {
    xs: TextInterface,
    sm: TextInterface,
    md: TextInterface,
    lg: TextInterface,
}

const themeText: TextThemeInterface = {
    xs: { fs: 10, lh: 14 },
    sm: { fs: 12, lh: 16 },
    md: { fs: 14, lh: 20 },
    lg: { fs: 16, lh: 24 },
};

export default themeText;
